import { render, staticRenderFns } from "./EditUnitOfMeasurePage.vue?vue&type=template&id=af591adc"
import script from "./EditUnitOfMeasurePage.vue?vue&type=script&lang=js"
export * from "./EditUnitOfMeasurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports